import { useEffect } from "react";

/**
 * Hook for keyboard navigation in PDF viewer
 * Handles global keyboard shortcuts for page navigation
 */
const useKeyboardNavigation = ({
  pdfPanelExpanded,
  currentPage,
  totalPages,
  setCurrentPage,
}) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Only handle when PDF panel is expanded and not in input fields
      if (
        !pdfPanelExpanded ||
        e.target.tagName === "INPUT" ||
        e.target.tagName === "TEXTAREA"
      ) {
        return;
      }

      if (e.key === "ArrowLeft") {
        e.preventDefault();
        e.stopPropagation();
        setCurrentPage(Math.max(1, currentPage - 1));
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        e.stopPropagation();
        setCurrentPage(Math.min(totalPages, currentPage + 1));
      }
    };

    // Add event listener to document for global keyboard shortcuts
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [pdfPanelExpanded, currentPage, totalPages, setCurrentPage]);

  // This hook only provides side effects (keyboard handling), no return value needed
  return {};
};

export default useKeyboardNavigation;
